// extracted by mini-css-extract-plugin
export default {"section":"CB-z","inSectionButton":"DB-z","addressCard":"EB-z","disabled":"FB-z","cautionBox":"GB-z","failureBox":"HB-z","fade-out":"IB-z","successBox":"JB-z"};